// extracted by mini-css-extract-plugin
export default {"button":"R0lVn","section":"GSKl3","sectionSelected":"geuYh","removeBtn":"wFwdP","name":"KOrZn","inner":"Ay36e"};